/**
 * Dual Physical/Digital ATC on product cards.
 * Empire only binds the first [data-quick-buy]; a hidden proxy receives that
 * binding while visible triggers set the variant id and click the proxy.
 */
(function () {
  function onChoiceTriggerClick(event) {
    const trigger = event.target.closest('[data-choice-trigger]');
    if (!trigger || trigger.disabled) return;

    const actions = trigger.closest('[data-medium-choice-actions]');
    if (!actions) return;

    const proxy = actions.querySelector('[data-choice-proxy]');
    if (!proxy) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return;

    proxy.setAttribute('data-variant-id', variantId);
    proxy.disabled = false;

    trigger.classList.add('processing');
    proxy.classList.add('processing');

    const clearProcessing = function () {
      trigger.classList.remove('processing');
      proxy.classList.remove('processing');
      document.removeEventListener('cart:updated', clearProcessing);
    };

    document.addEventListener('cart:updated', clearProcessing);
    window.setTimeout(clearProcessing, 4000);

    proxy.click();
  }

  document.addEventListener('click', onChoiceTriggerClick);
})();
